import Vue from 'vue'
import Vuex from 'vuex'
import { adminLogin, getAdminMe } from '../api/auth'
import {
  clearAuth,
  getAdminInfo,
  getPermissionCodes,
  getToken,
  setAdminInfo,
  setPermissionCodes,
  setToken
} from '../utils/auth'
import { getDefaultLayoutSettings, getLayoutSettings, setLayoutSettings } from '../utils/layout'

Vue.use(Vuex)

const defaultLayoutSettings = getLayoutSettings()

export default new Vuex.Store({
  state: {
    token: getToken(),
    adminInfo: getAdminInfo(),
    permissionCodes: getPermissionCodes(),
    layoutSettings: defaultLayoutSettings,
    locked: false,
    lockPassword: '',
    visitedViews: []
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      setToken(token)
    },
    setAdminInfo(state, info) {
      state.adminInfo = info
      setAdminInfo(info)
    },
    setPermissionCodes(state, codes) {
      state.permissionCodes = codes || []
      setPermissionCodes(codes || [])
    },
    setLayoutSettings(state, settings) {
      state.layoutSettings = {
        ...state.layoutSettings,
        ...settings
      }
      setLayoutSettings(state.layoutSettings)
    },
    lockScreen(state, password) {
      state.locked = true
      state.lockPassword = password || ''
    },
    unlockScreen(state) {
      state.locked = false
      state.lockPassword = ''
    },
    addVisitedView(state, view) {
      if (!view || !view.path || view.metaHidden) {
        return
      }
      if (state.visitedViews.find(item => item.path === view.path)) {
        return
      }
      state.visitedViews.push(view)
    },
    removeVisitedView(state, path) {
      state.visitedViews = state.visitedViews.filter(item => item.path !== path)
    },
    clearVisitedViews(state) {
      state.visitedViews = []
    },
    resetState(state) {
      state.token = ''
      state.adminInfo = null
      state.permissionCodes = []
      state.locked = false
      state.lockPassword = ''
      state.visitedViews = []
      clearAuth()
    }
  },
  actions: {
    async login({ commit }, payload) {
      const data = await adminLogin(payload)
      commit('setToken', data.token)
      commit('setAdminInfo', {
        userId: data.userId,
        username: data.username,
        realName: data.realName,
        roleCodes: data.roleCodes || []
      })
      commit('setPermissionCodes', data.permissionCodes || [])
      return data
    },
    async refreshMe({ commit }) {
      const data = await getAdminMe()
      commit('setAdminInfo', {
        userId: data.userId,
        username: data.username,
        realName: data.realName,
        roleCodes: data.roleCodes || []
      })
      commit('setPermissionCodes', data.permissionCodes || [])
      return data
    },
    logout({ commit }) {
      commit('resetState')
    },
    saveLayoutSettings({ commit }, settings) {
      commit('setLayoutSettings', settings)
    },
    lockScreen({ commit }, password) {
      commit('lockScreen', password)
    },
    unlockScreen({ commit, state }, password) {
      if (!state.lockPassword) {
        commit('unlockScreen')
        return true
      }
      if (state.lockPassword === password) {
        commit('unlockScreen')
        return true
      }
      return false
    },
    addVisitedView({ commit }, route) {
      commit('addVisitedView', {
        path: route.path,
        title: route.meta && route.meta.title ? route.meta.title : route.name || route.path,
        metaHidden: route.meta && route.meta.hidden,
        affix: route.meta && route.meta.affix
      })
    },
    removeVisitedView({ commit }, path) {
      commit('removeVisitedView', path)
    },
    resetLayoutSettings({ commit }) {
      commit('setLayoutSettings', getDefaultLayoutSettings())
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    permissionCodes: state => state.permissionCodes || [],
    adminName: state => (state.adminInfo && state.adminInfo.realName) || '管理员',
    layoutSettings: state => state.layoutSettings,
    isLocked: state => state.locked,
    visitedViews: state => state.visitedViews || []
  }
})
